import { supabase } from '../config/supabase';
import { UserProfile } from '../types';

export const profileService = {
  // Fetch user profile
  async getProfile(userId: string): Promise<UserProfile | null> {
    try {
      const { data, error } = await supabase.from('profiles').select('*').eq('id', userId).single();

      if (error) {
        console.error('Error fetching profile:', error);
        return null;
      }

      return data as unknown as UserProfile;
    } catch (error) {
      console.error('Error in getProfile:', error);
      return null;
    }
  },

  // Update user profile
  async updateProfile(userId: string, updates: Partial<UserProfile>): Promise<boolean> {
    try {
      const { error } = await supabase.from('profiles').update(updates).eq('id', userId);

      if (error) {
        console.error('Error updating profile:', error);
        return false;
      }

      return true;
    } catch (error) {
      console.error('Error in updateProfile:', error);
      return false;
    }
  },

  // Create profile (usually handled by trigger, but available as fallback)
  async createProfile(userId: string, email: string): Promise<boolean> {
    try {
      const { error } = await supabase.from('profiles').insert([{ id: userId, email }]);

      if (error) {
        console.error('Error creating profile:', error);
        return false;
      }

      return true;
    } catch (error) {
      console.error('Error in createProfile:', error);
      return false;
    }
  },

  // Check if profile exists
  async profileExists(userId: string): Promise<boolean> {
    try {
      const { data, error } = await supabase
        .from('profiles')
        .select('id')
        .eq('id', userId)
        .single();

      if (error && error.code !== 'PGRST116') {
        // PGRST116 is "not found"
        console.error('Error checking profile existence:', error);
        return false;
      }

      return !!data;
    } catch (error) {
      console.error('Error in profileExists:', error);
      return false;
    }
  },
};
